import { render, staticRenderFns } from "./CreateHelpTagCategoryPopUp.vue?vue&type=template&id=000f13c6&scoped=true"
import script from "./CreateHelpTagCategoryPopUp.vue?vue&type=script&lang=js"
export * from "./CreateHelpTagCategoryPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateHelpTagCategoryPopUp.vue?vue&type=style&index=0&id=000f13c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f13c6",
  null
  
)

export default component.exports